import type { ResourceResponse } from "types";
import { useFileUpload } from "hooks";
import { ApiRoutes } from "consts/enpoints/api";
import { ECommerceOnboardingFilableResource } from "consts/ecommerce";
import { HighRiskMerchant as HighRiskMerchantType } from "features/ecommerce/types";
import { HighRiskMerchant } from "ui/forms/ECommerce";

export const useShareholderFileUpload = () => {
    const uploadFile = useFileUpload();

    const handleShareholderFileUpload = (shareholder: HighRiskMerchant.DirectorsAndShareholders.Shareholder) =>
        async ({ data }: ResourceResponse<HighRiskMerchantType.Shareholder>) => {
            const requests = Array.from<ReturnType<typeof uploadFile>>([]);

            for (const field of [
                HighRiskMerchant.DirectorsAndShareholders.FormField.OtherPeople.PassportFileKey,
                HighRiskMerchant.DirectorsAndShareholders.FormField.OtherPeople.UtilityBillFileKey
            ]) {
                const file = shareholder[field];

                if (!file || !(file instanceof File)) {
                    continue;
                }

                requests.push(
                    uploadFile({
                        url: ApiRoutes.PostOnboardingsFiles(),
                        files: [
                            {
                                field,
                                file,
                                resource: ECommerceOnboardingFilableResource.ClientOtherPeople,
                                identifier: data.pki
                            }
                        ]
                    })
                );
            }

            return Promise.allSettled(requests);
        };

    return {
        handleShareholderFileUpload
    };
};

export default useShareholderFileUpload;
